import { render, staticRenderFns } from "./ProductListing.vue?vue&type=template&id=03ade782&"
import script from "./ProductListing.vue?vue&type=script&lang=js&"
export * from "./ProductListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03ade782')) {
      api.createRecord('03ade782', component.options)
    } else {
      api.reload('03ade782', component.options)
    }
    module.hot.accept("./ProductListing.vue?vue&type=template&id=03ade782&", function () {
      api.rerender('03ade782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/themes/default-amp/components/core/ProductListing.vue"
export default component.exports